import { Panel } from '../ui/Panel';
import { StaffDot } from '../agenda/StaffDot';
import { money } from '../../core/format/currency';
import { staffName } from '../../core/rules/salonDays';
import type { PerformerBreakdown } from '../../core/types/adminRequests';
import type { StaffProfile } from '../../core/types/site';
type Props = {
  rows: PerformerBreakdown[];
  team: readonly StaffProfile[];
};

/**
 * Salonomzet per uitvoerder (wie de bon uitvoerde), een tabel: vergelijken, niet bewonderen.
 * Samen precies de salonomzet; retouren gaan af bij wie de bon uitvoerde. De webshop heeft geen uitvoerder.
 */
export function PerformerPanel({
  rows,
  team
}: Props) {
  const total = rows.reduce((s, r) => s + r.revenueExVatCents, 0);
  return <Panel title="Per uitvoerder" description="Salonomzet excl. btw, naar wie de bon uitvoerde. Samen de salonomzet." flush data-id="element-3797" data-mp="2k0ttf7cpd9ky">
      {rows.length === 0 ? <p className="px-4 py-8 text-center text-[13px] text-muted sm:px-5" data-id="element-3798" data-mp="2t0gvlvd9ajf2">Geen salonverkopen in deze periode.</p> : <table className="w-full text-[14px]" data-id="element-3799" data-mp="i2jfoctnfazf">
          <caption className="sr-only" data-id="element-3800" data-mp="i3ku8r9viflw">Salonomzet per uitvoerder</caption>
          <thead className="text-[12px] text-muted" data-id="element-3801" data-mp="n1mbd6nqo4uq">
            <tr className="border-b border-line" data-id="element-3802" data-mp="rzxn5mxlgpfl">
              <th scope="col" className="px-4 py-2 text-left font-normal sm:px-5" data-id="element-3803" data-mp="rycp3nc2mocz">Wie</th>
              <th scope="col" className="hidden px-2 py-2 text-right font-normal sm:table-cell" data-id="element-3804" data-mp="w2ape1d4u57m">Behandelingen</th>
              <th scope="col" className="hidden px-2 py-2 text-right font-normal sm:table-cell" data-id="element-3805" data-mp="1102pvjrueznf">Producten</th>
              <th scope="col" className="px-4 py-2 text-right font-normal sm:px-5" data-id="element-3806" data-mp="15xufg750m9og">Omzet</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-line" data-id="element-3807" data-mp="1fpieat3wiszy">
            {rows.map(r => <tr key={r.staffId} data-id="element-3808" data-mp="1frbcrl4d26wv">
                <td className="px-4 py-2.5 sm:px-5" data-id="element-3809" data-mp="1jrlqjjyea1ma">
                  <span className="inline-flex items-center gap-2 text-ink" data-id="element-3810" data-mp="1jp0pgx5x7ppl">
                    <StaffDot staff={team} id={r.staffId} size="sm" data-id="element-3811" data-mp="1oqq0wdx225e7" />
                    {staffName(team, r.staffId)}
                  </span>
                </td>
                <td className="hidden px-2 py-2.5 text-right tabular-nums sm:table-cell" data-id="element-3812" data-mp="3gs9hedr6yhgo">{money(r.treatmentsExVatCents)}</td>
                <td className="hidden px-2 py-2.5 text-right tabular-nums sm:table-cell" data-id="element-3813" data-mp="3ujwhkoo98a4q">{money(r.productsExVatCents)}</td>
                <td className="px-4 py-2.5 text-right tabular-nums text-ink sm:px-5" data-id="element-3814" data-mp="3pr3cu0ssd1sn">
                  {money(r.revenueExVatCents)}
                  <span className="block text-[12px] text-muted" data-id="element-3815" data-mp="3d3grlxdid0q">{total > 0 ? Math.round(r.revenueExVatCents / total * 100) : 0}%</span>
                </td>
              </tr>)}
          </tbody>
        </table>}
    </Panel>;
}